import { render, staticRenderFns } from "./Food.vue?vue&type=template&id=33bd8c7f&scoped=true"
import script from "./Food.vue?vue&type=script&lang=js"
export * from "./Food.vue?vue&type=script&lang=js"
import style0 from "./Food.vue?vue&type=style&index=0&id=33bd8c7f&lang=scss&scoped=true"
import style1 from "./Food.vue?vue&type=style&index=1&id=33bd8c7f&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd8c7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050store/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33bd8c7f')) {
      api.createRecord('33bd8c7f', component.options)
    } else {
      api.reload('33bd8c7f', component.options)
    }
    module.hot.accept("./Food.vue?vue&type=template&id=33bd8c7f&scoped=true", function () {
      api.rerender('33bd8c7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/Food.vue"
export default component.exports